import {
    collection,
    doc
} from "firebase/firestore";
import { firestore } from '../firebase';
import { useFirestoreDocumentData } from '@react-query-firebase/firestore';
import useBoardHook from './useBoardHook';

const useGetAdminDataBoard = (subdomain) => {
    const getDocumentBoard = useBoardHook(subdomain);

    const refAdmin = doc (collection(firestore, 'public_users'), getDocumentBoard?.data?.admin || "a");
    const getAdmin = useFirestoreDocumentData(['public_users', getDocumentBoard?.data?.admin], refAdmin, {}, {enabled: !!getDocumentBoard?.data?.admin});

  return { getAdmin: getAdmin.data, isLoadingAdmin: getAdmin.isLoading }
}

export default useGetAdminDataBoard